import { Routes, Route } from 'react-router-dom';
import GeneralEquipmentItems from '../child_components/GeneralEquipmentItems';
import GeneralEquipment from '../child_components/GeneralEquipment';

function GeneralEquipmentList() {
    

    return(
        <div className="p-4">
            <Routes>
                <Route path='/items' element={ <GeneralEquipmentItems /> } />
                <Route path='/' element={ <GeneralEquipment /> } />
            </Routes>
        </div>
    )
}

export default GeneralEquipmentList;